// src/router/routes.js
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import usuarios from '@/domains/shared/configuracoes/usuarios/router/routes'
import planos from '@/domains/shared/configuracoes/planos/router/routes'
import gruposUsuarios from '@/domains/shared/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/shared/configuracoes/permissoes/router/routes'
// import carteira from '@/domains/shared/carteira/router/routes'

const isProd = process.env.NODE_ENV === 'production'
const BASE = process.env.VUE_APP_FRONT_URL_AGENDA_PRO
const SLUG = ':slug'

const ExternoPersonalizado = () =>
    import('../layouts/adminlte/components/Interno')

let childrenRoutes = []
const domainsContext = require.context('../../domains/', true, /routes\.js$/i)
domainsContext.keys().forEach(key => {
    const moduleRoutes = domainsContext(key).default
    if (Array.isArray(moduleRoutes)) {
        childrenRoutes.push(...moduleRoutes)
    }
})

const routes = [
    {
        path: '',
        component: ExternoPersonalizado,
        children: [
            // Rota para o Portal (página inicial)
            {
                name: 'agendaProPortal',
                path: isProd
                    ? `${BASE}`
                    : `${BASE}/${SLUG}`,
                alias: isProd
                    ? [`${BASE}/`]
                    : [`${BASE}/${SLUG}`],
                meta: { 
                    public: true,
                    slug: SLUG
                },
                component: () =>
                    import('../../domains/meus_agendamentos/views/Portal')
            },
            // Rota para Agendamento
            {
                name: 'agendaProAgendar',
                path: isProd
                    ? `${BASE}/agendar`
                    : `${BASE}/${SLUG}/agendar`,
                meta: { 
                    public: true,
                    slug: SLUG
                },
                component: () =>
                    import('../../domains/meus_agendamentos/views/MeusAgendamentos')
            },
            // Rota para Listagem de Agendamentos
            {
                name: 'agendaProListagem',
                path: isProd
                    ? `${BASE}/meus_agendamentos`
                    : `${BASE}/${SLUG}/meus_agendamentos`,
                meta: { 
                    public: true,
                    slug: SLUG
                },
                component: () =>
                    import('../../domains/meus_agendamentos/views/Listagem')
            }
        ]
    },
    {

        path: isProd
            ? `/${BASE}`
            : `/${BASE}/${SLUG}`,
        component: () => import('@/shared/components/layout/Interno'),
        children: childrenRoutes
    },
    ...formataRotasGlobais(BASE, usuarios),
    ...formataRotasGlobais(BASE, planos),
    ...formataRotasGlobais(BASE, gruposUsuarios),
    ...formataRotasGlobais(BASE, permissoes)
    // ...formataRotasGlobais(BASE, carteira)
]

export default routes
